import { ComponentProps, ReactElement } from "react";
import styled from "styled-components";

import { PageBody } from "../PageBody";
import { Typography } from "../../atoms/Typography";
import { List, ListItem } from "../../atoms/List";
import { hexToRGB } from "../../../utils/style";
import userIcon from "../../../assets/images/users/sample.png";
import { DeliveryOrder, Product } from "../../../types";

/**
 * 物品情報詳細
 */

export type DeliveryOrderProducts = {
  product: Product;
  quantity: number | null | undefined;
  serialNumber: string | null | undefined;
};

export type DeliveryOrderProps = {
  deliveryOrder: DeliveryOrder;
  products?: ReactElement;
};

const ContentWrapper = styled.div`
  padding: 0 40px;
`;

const Inner = styled.div`
  padding: 40px 0 20px;
  display: flex;
  ${(props) => hexToRGB(props.theme.colors.primaryBorder, 0.5)};
`;

const LeftBlock = styled.div`
  flex: 1;
  padding-right: 40px;
`;

const MemberIconAndName = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 20px;
  }
`;

const RightBlock = styled.div`
  flex: 1;
  padding-left: 40px;
`;

const PaddingRightWrapper = styled.div`
  width: 100%;
  padding-right: 20px;
`;

const TextRightTypography = (props: ComponentProps<typeof Typography>) => (
  <PaddingRightWrapper>
    <Typography textRight size={2}>
      {props.children}
    </Typography>
  </PaddingRightWrapper>
);

export function DeliveryOrderDetailPage({
  deliveryOrder,
  products,
}: DeliveryOrderProps) {
  return (
    <>
      <PageBody title="物品情報詳細">
        <>
          <ContentWrapper>
            <Inner>
              <LeftBlock>
                <MemberIconAndName>
                  <img
                    src={userIcon}
                    width="72"
                    height="72"
                    alt={"user_icon"}
                  />
                  <Typography size={5} breakWord>
                    {deliveryOrder.name}
                  </Typography>
                </MemberIconAndName>
              </LeftBlock>
            </Inner>
          </ContentWrapper>

          <ContentWrapper>
            <Inner>
              <LeftBlock>
                <List>
                  <ListItem>
                    <Typography bold size={1}>
                      郵便番号
                    </Typography>
                    <TextRightTypography>
                      {deliveryOrder.postalCode}
                    </TextRightTypography>
                  </ListItem>
                  <ListItem>
                    <Typography bold size={1}>
                      住所
                    </Typography>
                    <TextRightTypography>
                      {deliveryOrder.address}
                    </TextRightTypography>
                  </ListItem>
                  <ListItem>
                    <Typography bold size={1}>
                      配送日
                    </Typography>
                    <TextRightTypography>
                      {deliveryOrder.deliveryDate || "-"}
                    </TextRightTypography>
                  </ListItem>
                </List>
              </LeftBlock>
              <RightBlock>
                <List>
                  <ListItem>
                    <Typography bold size={1}>
                      電話番号
                    </Typography>
                    <TextRightTypography>
                      {deliveryOrder.phoneNumber}
                    </TextRightTypography>
                  </ListItem>
                  <ListItem>
                    <Typography bold size={1}>
                      配送番号
                    </Typography>
                    <TextRightTypography>
                      {(deliveryOrder.deliveryHistory.length > 0 &&
                        deliveryOrder.deliveryHistory[0]?.slipNumber) ||
                        "-"}
                    </TextRightTypography>
                  </ListItem>
                  <ListItem>
                    <Typography bold size={1}>
                      -
                    </Typography>
                    <TextRightTypography>-</TextRightTypography>
                  </ListItem>
                </List>
              </RightBlock>
            </Inner>
          </ContentWrapper>
          {products}
        </>
      </PageBody>
    </>
  );
}
